class DistanceConverter {
  static KM_TO_METERS = 1000;
  static MI_TO_METERS = 1609.34;
  static KM_TO_MILES = 0.621371;
  static METER_TO_FEETS = 3.28084;
  static CM_TO_IN = 0.393700787402;

  constructor(value) {
    this.value = value;
  }

  convert(direction) {
    console.log(`Converting ${this.value} in direction ${direction}`);
    switch (direction) {
      case 'km_to_m':
        return Math.round(this.value * DistanceConverter.KM_TO_METERS);
      case 'mi_to_m':
        return Math.round(this.value * DistanceConverter.MI_TO_METERS);
      case 'm_to_mi':
        return Math.round((this.value / DistanceConverter.MI_TO_METERS) * 10) / 10;
      case 'km_to_mi':
        return Math.round(this.value * DistanceConverter.KM_TO_MILES * 10) / 10;
      case 'm_to_ft':
        return Math.round(this.value * DistanceConverter.METER_TO_FEETS);
      case 'ft_to_m':
        return Math.round(this.value / DistanceConverter.METER_TO_FEETS);
      case 'cm_to_in':
        return Math.round(this.value * DistanceConverter.CM_TO_IN);
      case 'in_to_cm':
        return Math.round(this.value / DistanceConverter.CM_TO_IN);
      case 'mi_to_km':
        return Math.round(this.value * DistanceConverter.MI_TO_METERS / DistanceConverter.KM_TO_METERS * 10) / 10;
      case 'm_to_km':
        return Math.round(this.value / DistanceConverter.KM_TO_METERS * 10) / 10;
      default:
        return this.value;
    }
  }
}

export default DistanceConverter;

